// extracted by mini-css-extract-plugin
module.exports = {"section":"BottomAction_section__HX8SZ","show":"BottomAction_show__zXdym"};